"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _group_buy = require("@/api/goods_activity/group_buy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {},
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      tableKey: 0,
      listQuery: {
        goodsPromotionType: this.goodsPromotionType,
        page: 1,
        limit: 20,
        keywords: ''
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleEdit: function handleEdit(row) {
      this.$emit('toConfig', row.fnId);
    },
    handleAdd: function handleAdd() {
      this.$emit('toConfig');
    },
    handleToggleEnable: function handleToggleEnable(row) {
      var _this = this;
      (0, _group_buy.toggleEnable)(row.fnId, row.markForEnable).then(function () {
        _this.$message.success('状态修改成功');
      }).catch(function () {
        // 失败时恢复原状态
        row.markForEnable = !row.markForEnable;
      });
    },
    search: function search() {
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this2 = this;
      this.loading = true;
      (0, _group_buy.queryGroupBuyPage)(this.listQuery).then(function (res) {
        _this2.tableData = res.records;
        _this2.total = res.total;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};